import { ChangeEvent, SelectHTMLAttributes } from 'react'

import * as S from './styles'

type SelectTypes = SelectHTMLAttributes<HTMLSelectElement>

type SelectInputProps = {
  label?: string
  labelColor?: string
  hasTestSelectInput?: boolean
  hasConclusionInput?: boolean
  hasQuestionInput?: boolean
  hasSelectOption?: boolean
  hasAvaibleDefault?: boolean
  name: string
  options?: {
    value: string | number
    label: string | number
  }[]
  onChange?(event: ChangeEvent<HTMLSelectElement>): void | undefined
  defaultValue?: string | number
  wrapperClassName?: string
} & SelectTypes

const SelectInput = ({
  hasAvaibleDefault,
  label,
  labelColor,
  hasTestSelectInput = false,
  hasConclusionInput = false,
  hasQuestionInput = false,
  hasSelectOption = true,
  name,
  options,
  onChange,
  defaultValue,
  wrapperClassName,
  ...props
}: SelectInputProps) => (
  <S.Wrapper
    className={wrapperClassName}
    hasTestSelectInput={hasTestSelectInput}
    hasConclusionInput={hasConclusionInput}
    hasQuestionInput={hasQuestionInput}
  >
    <label style={{ color: labelColor }} htmlFor={name}>
      {label}
    </label>
    <select onChange={onChange} defaultValue={defaultValue} {...props}>
      {hasSelectOption && (
        <option value="" selected={!defaultValue} disabled>
          Selecione...
        </option>
      )}
      {hasAvaibleDefault && (
        <option value="" selected={!defaultValue} disabled>
          Selecione...
        </option>
      )}
      {options?.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  </S.Wrapper>
)

export default SelectInput
